import { Component, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '@tytapp/common';
import { UserService } from '@tytapp/user';
import { ApiUser, UsersApi } from '@tytapp/api';

@Component({
    selector: 'app-delete-user-data',
    templateUrl: './delete-user-data.component.html',
    styleUrls: ['./delete-user-data.component.scss']
})
export class DeleteUserDataComponent extends BaseComponent {
    private userService = inject(UserService);
    private userApi = inject(UsersApi);

    confirmEnabled = false;
    showPasswordConfirmation = false;
    showSpinner = false;

    private _userChangedSub: Subscription = null;
    private _userDeletionSub: Subscription = null;

    password: string = '';
    errorMsg: string = '';

    user: ApiUser;

    get hasCancelableMembership() {
        if (!this.user)
            return false;

        if (!this.user.membership)
            return false;

        if (!this.user.membership.active)
            return false;

        if (this.user.membership.gateway_name === 'free')
            return false;

        return true;
    }

    goBack() {
        this.router.navigate(['/settings/privacy-controls']);
    }

    async submit() {
        this.errorMsg = '';

        if (!this.showPasswordConfirmation) {
            this.showPasswordConfirmation = true;
            return;
        }

        if (this.password != '') {
            this.showSpinner = true;
            try {
                await this.userApi.deleteCurrentUser({ password: this.password }).toPromise();
                this.deletionSuccessful = true;
                this.userService.completeLogout();
            } catch (e) {
                if (e.json)
                    e = e.json();

                this.showSpinner = false;
                this.errorMsg = e.message || e.error;

                if (this.errorMsg === '') {
                    this.errorMsg = `
                        Uh oh, looks like there's a problem on our end.
                        Please try again later, if this issue persists
                        please contact support@tytnetwork.com
                    `;
                }
            }
        } else {
            this.errorMsg = 'Please enter your password to continue';
        }
    }

    originalUser: ApiUser;
    deletionSuccessful = false;

    init() {
        this._userChangedSub = this.userService.userChanged.subscribe(user => {
            if (!user && !this.deletionSuccessful) {
                this.userService.goToLogin();
                return;
            }
            this.user = user;
            if (user)
                this.originalUser = user;
        });
    }

    destroy() {
        this._userChangedSub.unsubscribe();
        if (this._userDeletionSub) {
            this._userDeletionSub.unsubscribe();
        }
    }

}
